import { useCallback, useRef } from "react";

type Tone = "start" | "stop" | "error";

const TONE_FREQUENCIES: Record<Tone, number> = {
  start: 880,
  stop: 440,
  error: 220,
};

export function useSoundEffects(enabled: boolean) {
  const contextRef = useRef<AudioContext | null>(null);

  const play = useCallback(
    (tone: Tone) => {
      if (!enabled) return;
      try {
        if (!contextRef.current) {
          contextRef.current = new AudioContext();
        }
        const ctx = contextRef.current;
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        oscillator.frequency.value = TONE_FREQUENCIES[tone];
        oscillator.type = "sine";
        gain.gain.setValueAtTime(0.08, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.18);
        oscillator.connect(gain);
        gain.connect(ctx.destination);
        oscillator.start();
        oscillator.stop(ctx.currentTime + 0.18);
      } catch {
        // Audio context may be blocked until a user gesture — safe to ignore.
      }
    },
    [enabled],
  );

  return play;
}
